// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  color: #1f2933;
  font-family:
    "Segoe UI",
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    sans-serif;
  font-size: 14px;
}

body {
  background: #f7f9fc;
  margin: 0;
}

.app {
  display: grid;
  gap: 12px;
  min-height: calc(100vh - 32px);
  padding: 16px;
}

.app-version {
  align-self: end;
  color: #9aa8b7;
  font-size: 11px;
  justify-self: center;
  padding-top: 8px;
}

.hero,
.panel {
  background: #ffffff;
  border: 1px solid #dde5ef;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgb(16 24 40 / 6%);
  padding: 12px 14px;
}

.app-menu {
  position: relative;
}

.app-menu summary {
  align-items: center;
  background: #e8f0fe;
  border-radius: 8px;
  color: #1d4ed8;
  cursor: pointer;
  display: inline-flex;
  font-weight: 700;
  font-size: 12px;
  height: 32px;
  justify-content: center;
  line-height: 1;
  list-style: none;
  padding: 0 10px;
}

.app-menu summary::-webkit-details-marker {
  display: none;
}

.app-menu-panel {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  box-shadow: 0 8px 20px rgb(15 23 42 / 12%);
  display: grid;
  min-width: 130px;
  overflow: hidden;
  position: absolute;
  left: 0;
  top: 36px;
  z-index: 3;
}

.app-menu-panel button {
  background: #ffffff;
  border-radius: 0;
  color: #1f2933;
  padding: 8px 10px;
  text-align: left;
}

.app-menu-panel button:hover {
  background: #f8fafc;
}

.is-hidden {
  display: none;
}

.eyebrow {
  color: #2563eb;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  margin: 0 0 2px;
  text-transform: uppercase;
}

h1,
h2,
h3,
p {
  margin-top: 0;
}

h1 {
  font-size: 20px;
  margin-bottom: 4px;
}

h2 {
  align-items: center;
  display: flex;
  font-size: 18px;
  gap: 8px;
  justify-content: space-between;
}

h2 span {
  background: #e8f0fe;
  border-radius: 999px;
  color: #1d4ed8;
  font-size: 12px;
  padding: 2px 8px;
}

.section-heading {
  align-items: center;
  display: flex;
  gap: 8px;
  justify-content: space-between;
  margin-bottom: 14px;
  min-width: 0;
}

.section-heading h2 {
  flex: 1 1 auto;
  justify-content: flex-start;
  margin-bottom: 0;
  min-width: 0;
}

.section-add-button {
  align-items: center;
  border-radius: 999px;
  box-sizing: border-box;
  display: inline-flex;
  flex: 0 0 24px;
  font-size: 15px;
  height: 24px;
  justify-content: center;
  line-height: 1;
  min-width: 24px;
  padding: 0;
  width: 24px;
}

h3 {
  font-size: 15px;
  margin-bottom: 4px;
}

a {
  color: #1d4ed8;
  font-weight: 700;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

.summary,
.status,
.empty,
.record p {
  color: #52616f;
}

.summary {
  margin-bottom: 0;
}

.status {
  margin: 0;
  min-height: 20px;
}

.toolbar {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.toolbar button {
  font-size: 12px;
  min-height: 32px;
  padding: 7px 10px;
}

.toolbar button:disabled {
  opacity: 0.75;
}

button {
  background: #2563eb;
  border: 0;
  border-radius: 8px;
  color: #ffffff;
  cursor: pointer;
  font-weight: 700;
  padding: 10px 12px;
}

button:disabled {
  background: #9aa8b7;
  cursor: not-allowed;
}

.secondary-button {
  background: #e8f0fe;
  color: #1d4ed8;
}

.icon-button {
  background: #e8f0fe;
  border-radius: 999px;
  color: #1d4ed8;
  height: 28px;
  line-height: 1;
  padding: 0;
  width: 28px;
}

.credential-status {
  color: #52616f;
  margin-bottom: 10px;
}

.credential-status.is-connected {
  color: #166534;
}

.group + .group {
  border-top: 1px solid #e5ebf2;
  margin-top: 16px;
  padding-top: 16px;
}

.record {
  background: #f8fafc;
  border: 1px solid #e5ebf2;
  border-radius: 10px;
  margin-top: 10px;
  padding: 12px;
}

.notice-card {
  background: #eef6ff;
  border: 1px solid #bfdbfe;
  border-radius: 10px;
  color: #1e3a8a;
  margin-bottom: 12px;
  padding: 10px 12px;
}

.duplicate-group {
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 10px;
  padding: 12px;
}

.primary-match-group {
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 10px;
  padding: 12px;
}

.primary-match-group p {
  margin-bottom: 6px;
}

.primary-match-group span {
  color: #52616f;
  display: block;
  font-size: 12px;
  margin-top: 2px;
}

.duplicate-group ul {
  display: grid;
  gap: 8px;
  list-style: none;
  margin: 10px 0;
  padding: 0;
}

.duplicate-group li {
  display: grid;
  gap: 2px;
}

.duplicate-group li span {
  color: #52616f;
  font-size: 12px;
}

.smart-merge-button {
  background: #c2410c;
}

.record ul,
.notes {
  display: grid;
  gap: 4px;
  list-style: none;
  margin: 8px 0 0;
  padding: 0;
}

.record li {
  display: grid;
  gap: 4px;
  grid-template-columns: 120px 1fr;
}

.record strong {
  color: #3c4856;
}

.client-order-ref {
  color: #52616f;
  margin-bottom: 10px;
}

.compact-details {
  gap: 6px;
}

.compact-details li {
  display: block;
}

.record-line {
  align-items: center;
  display: flex;
  gap: 8px;
  position: relative;
}

.record-line h3 {
  margin-bottom: 0;
}

.record-actions {
  display: flex;
  gap: 5px;
}

.record-action {
  align-items: center;
  background: #e8f0fe;
  border-radius: 999px;
  display: inline-flex;
  height: 20px;
  justify-content: center;
  line-height: 1;
  width: 20px;
}

.record-action svg {
  fill: currentColor;
  height: 13px;
  width: 13px;
}

.contact-function {
  color: #7b8794;
  font-size: 13px;
  margin: 4px 0 0;
}

.decision-maker-icon {
  color: #ca8a04;
  display: inline-flex;
  margin-left: auto;
}

.decision-maker-icon svg {
  fill: currentColor;
  height: 16px;
  width: 16px;
}

.decision-maker-icon.is-hidden {
  display: none;
}

.contact-menu {
  margin-left: auto;
  opacity: 0;
  position: relative;
  transition: opacity 120ms ease;
}

.decision-maker-icon:not(.is-hidden) + .contact-menu {
  margin-left: 0;
}

.contact-record:hover .contact-menu,
.contact-menu[open] {
  opacity: 1;
}

.contact-menu summary {
  align-items: center;
  background: #e8f0fe;
  border-radius: 999px;
  color: #1d4ed8;
  cursor: pointer;
  display: inline-flex;
  font-weight: 700;
  height: 20px;
  justify-content: center;
  list-style: none;
  width: 20px;
}

.contact-menu summary::-webkit-details-marker {
  display: none;
}

.contact-menu button {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  box-shadow: 0 8px 20px rgb(15 23 42 / 12%);
  color: #1f2933;
  min-width: 170px;
  padding: 8px 10px;
  position: absolute;
  right: 0;
  top: 24px;
  z-index: 2;
}

.contact-menu button:disabled {
  color: #7b8794;
}

.compact-meta {
  align-items: center;
  color: #52616f;
  display: flex;
  gap: 5px;
  margin: 8px 0 0;
}

.compact-meta svg {
  fill: currentColor;
  height: 14px;
  width: 14px;
}

.quality-check {
  align-items: center;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 8px;
  display: flex;
  gap: 8px;
  margin: 8px 0 10px;
  padding: 8px;
}

.quality-check span {
  color: #9a3412;
  font-weight: 700;
  white-space: nowrap;
}

.quality-check select {
  border: 1px solid #fdba74;
  border-radius: 6px;
  flex: 1;
  font: inherit;
  min-width: 0;
  padding: 6px 8px;
}

.marketing-switch {
  align-items: center;
  color: #52616f;
  display: flex;
  font-weight: 700;
  gap: 8px;
  margin-top: 10px;
}

.marketing-switch input {
  appearance: none;
  background: #cbd5e1;
  border: 0;
  border-radius: 999px;
  cursor: pointer;
  height: 18px;
  padding: 0;
  position: relative;
  transition: background 120ms ease;
  width: 34px;
}

.marketing-switch input::after {
  background: #ffffff;
  border-radius: 50%;
  content: "";
  height: 14px;
  left: 2px;
  position: absolute;
  top: 2px;
  transition: transform 120ms ease;
  width: 14px;
}

.marketing-switch input:checked {
  background: #2563eb;
}

.marketing-switch input:checked::after {
  transform: translateX(16px);
}

.marketing-switch input:disabled {
  cursor: default;
}

.marketing-switch.is-enabled span {
  color: #166534;
}

.sales-order-details {
  gap: 6px;
}

.sales-order-details li {
  display: block;
}

.state-badge {
  border-radius: 999px;
  display: inline-block;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  padding: 3px 7px;
  width: fit-content;
}

.state-draft {
  background: #e5e7eb;
  color: #374151;
}

.state-sent {
  background: #dbeafe;
  color: #1d4ed8;
}

.state-sale,
.state-done {
  background: #dcfce7;
  color: #166534;
}

.state-cancel {
  background: #fee2e2;
  color: #991b1b;
}

.form {
  display: grid;
  gap: 10px;
}

.form-actions {
  display: flex;
  gap: 8px;
}

label {
  display: grid;
  gap: 4px;
}

.checkbox {
  align-items: center;
  display: flex;
  font-weight: 700;
  gap: 8px;
  margin-top: 8px;
}

input {
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font: inherit;
  padding: 9px 10px;
}
`, "",{"version":3,"sources":["webpack://./src/taskpane/taskpane.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd;;;;;cAKY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,QAAQ;EACR,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,UAAU;EACV,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,cAAc;EACd,UAAU;EACV,WAAW;AACb;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,OAAO;EACP,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;AACnB","sourcesContent":[":root {\n  color: #1f2933;\n  font-family:\n    \"Segoe UI\",\n    system-ui,\n    -apple-system,\n    BlinkMacSystemFont,\n    sans-serif;\n  font-size: 14px;\n}\n\nbody {\n  background: #f7f9fc;\n  margin: 0;\n}\n\n.app {\n  display: grid;\n  gap: 12px;\n  min-height: calc(100vh - 32px);\n  padding: 16px;\n}\n\n.app-version {\n  align-self: end;\n  color: #9aa8b7;\n  font-size: 11px;\n  justify-self: center;\n  padding-top: 8px;\n}\n\n.hero,\n.panel {\n  background: #ffffff;\n  border: 1px solid #dde5ef;\n  border-radius: 12px;\n  box-shadow: 0 1px 2px rgb(16 24 40 / 6%);\n  padding: 12px 14px;\n}\n\n.app-menu {\n  position: relative;\n}\n\n.app-menu summary {\n  align-items: center;\n  background: #e8f0fe;\n  border-radius: 8px;\n  color: #1d4ed8;\n  cursor: pointer;\n  display: inline-flex;\n  font-weight: 700;\n  font-size: 12px;\n  height: 32px;\n  justify-content: center;\n  line-height: 1;\n  list-style: none;\n  padding: 0 10px;\n}\n\n.app-menu summary::-webkit-details-marker {\n  display: none;\n}\n\n.app-menu-panel {\n  background: #ffffff;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  box-shadow: 0 8px 20px rgb(15 23 42 / 12%);\n  display: grid;\n  min-width: 130px;\n  overflow: hidden;\n  position: absolute;\n  left: 0;\n  top: 36px;\n  z-index: 3;\n}\n\n.app-menu-panel button {\n  background: #ffffff;\n  border-radius: 0;\n  color: #1f2933;\n  padding: 8px 10px;\n  text-align: left;\n}\n\n.app-menu-panel button:hover {\n  background: #f8fafc;\n}\n\n.is-hidden {\n  display: none;\n}\n\n.eyebrow {\n  color: #2563eb;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  margin: 0 0 2px;\n  text-transform: uppercase;\n}\n\nh1,\nh2,\nh3,\np {\n  margin-top: 0;\n}\n\nh1 {\n  font-size: 20px;\n  margin-bottom: 4px;\n}\n\nh2 {\n  align-items: center;\n  display: flex;\n  font-size: 18px;\n  gap: 8px;\n  justify-content: space-between;\n}\n\nh2 span {\n  background: #e8f0fe;\n  border-radius: 999px;\n  color: #1d4ed8;\n  font-size: 12px;\n  padding: 2px 8px;\n}\n\n.section-heading {\n  align-items: center;\n  display: flex;\n  gap: 8px;\n  justify-content: space-between;\n  margin-bottom: 14px;\n  min-width: 0;\n}\n\n.section-heading h2 {\n  flex: 1 1 auto;\n  justify-content: flex-start;\n  margin-bottom: 0;\n  min-width: 0;\n}\n\n.section-add-button {\n  align-items: center;\n  border-radius: 999px;\n  box-sizing: border-box;\n  display: inline-flex;\n  flex: 0 0 24px;\n  font-size: 15px;\n  height: 24px;\n  justify-content: center;\n  line-height: 1;\n  min-width: 24px;\n  padding: 0;\n  width: 24px;\n}\n\nh3 {\n  font-size: 15px;\n  margin-bottom: 4px;\n}\n\na {\n  color: #1d4ed8;\n  font-weight: 700;\n  text-decoration: none;\n}\n\na:hover {\n  text-decoration: underline;\n}\n\n.summary,\n.status,\n.empty,\n.record p {\n  color: #52616f;\n}\n\n.summary {\n  margin-bottom: 0;\n}\n\n.status {\n  margin: 0;\n  min-height: 20px;\n}\n\n.toolbar {\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.toolbar button {\n  font-size: 12px;\n  min-height: 32px;\n  padding: 7px 10px;\n}\n\n.toolbar button:disabled {\n  opacity: 0.75;\n}\n\nbutton {\n  background: #2563eb;\n  border: 0;\n  border-radius: 8px;\n  color: #ffffff;\n  cursor: pointer;\n  font-weight: 700;\n  padding: 10px 12px;\n}\n\nbutton:disabled {\n  background: #9aa8b7;\n  cursor: not-allowed;\n}\n\n.secondary-button {\n  background: #e8f0fe;\n  color: #1d4ed8;\n}\n\n.icon-button {\n  background: #e8f0fe;\n  border-radius: 999px;\n  color: #1d4ed8;\n  height: 28px;\n  line-height: 1;\n  padding: 0;\n  width: 28px;\n}\n\n.credential-status {\n  color: #52616f;\n  margin-bottom: 10px;\n}\n\n.credential-status.is-connected {\n  color: #166534;\n}\n\n.group + .group {\n  border-top: 1px solid #e5ebf2;\n  margin-top: 16px;\n  padding-top: 16px;\n}\n\n.record {\n  background: #f8fafc;\n  border: 1px solid #e5ebf2;\n  border-radius: 10px;\n  margin-top: 10px;\n  padding: 12px;\n}\n\n.notice-card {\n  background: #eef6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 10px;\n  color: #1e3a8a;\n  margin-bottom: 12px;\n  padding: 10px 12px;\n}\n\n.duplicate-group {\n  background: #fff7ed;\n  border: 1px solid #fed7aa;\n  border-radius: 10px;\n  padding: 12px;\n}\n\n.primary-match-group {\n  background: #f0fdf4;\n  border: 1px solid #bbf7d0;\n  border-radius: 10px;\n  padding: 12px;\n}\n\n.primary-match-group p {\n  margin-bottom: 6px;\n}\n\n.primary-match-group span {\n  color: #52616f;\n  display: block;\n  font-size: 12px;\n  margin-top: 2px;\n}\n\n.duplicate-group ul {\n  display: grid;\n  gap: 8px;\n  list-style: none;\n  margin: 10px 0;\n  padding: 0;\n}\n\n.duplicate-group li {\n  display: grid;\n  gap: 2px;\n}\n\n.duplicate-group li span {\n  color: #52616f;\n  font-size: 12px;\n}\n\n.smart-merge-button {\n  background: #c2410c;\n}\n\n.record ul,\n.notes {\n  display: grid;\n  gap: 4px;\n  list-style: none;\n  margin: 8px 0 0;\n  padding: 0;\n}\n\n.record li {\n  display: grid;\n  gap: 4px;\n  grid-template-columns: 120px 1fr;\n}\n\n.record strong {\n  color: #3c4856;\n}\n\n.client-order-ref {\n  color: #52616f;\n  margin-bottom: 10px;\n}\n\n.compact-details {\n  gap: 6px;\n}\n\n.compact-details li {\n  display: block;\n}\n\n.record-line {\n  align-items: center;\n  display: flex;\n  gap: 8px;\n  position: relative;\n}\n\n.record-line h3 {\n  margin-bottom: 0;\n}\n\n.record-actions {\n  display: flex;\n  gap: 5px;\n}\n\n.record-action {\n  align-items: center;\n  background: #e8f0fe;\n  border-radius: 999px;\n  display: inline-flex;\n  height: 20px;\n  justify-content: center;\n  line-height: 1;\n  width: 20px;\n}\n\n.record-action svg {\n  fill: currentColor;\n  height: 13px;\n  width: 13px;\n}\n\n.contact-function {\n  color: #7b8794;\n  font-size: 13px;\n  margin: 4px 0 0;\n}\n\n.decision-maker-icon {\n  color: #ca8a04;\n  display: inline-flex;\n  margin-left: auto;\n}\n\n.decision-maker-icon svg {\n  fill: currentColor;\n  height: 16px;\n  width: 16px;\n}\n\n.decision-maker-icon.is-hidden {\n  display: none;\n}\n\n.contact-menu {\n  margin-left: auto;\n  opacity: 0;\n  position: relative;\n  transition: opacity 120ms ease;\n}\n\n.decision-maker-icon:not(.is-hidden) + .contact-menu {\n  margin-left: 0;\n}\n\n.contact-record:hover .contact-menu,\n.contact-menu[open] {\n  opacity: 1;\n}\n\n.contact-menu summary {\n  align-items: center;\n  background: #e8f0fe;\n  border-radius: 999px;\n  color: #1d4ed8;\n  cursor: pointer;\n  display: inline-flex;\n  font-weight: 700;\n  height: 20px;\n  justify-content: center;\n  list-style: none;\n  width: 20px;\n}\n\n.contact-menu summary::-webkit-details-marker {\n  display: none;\n}\n\n.contact-menu button {\n  background: #ffffff;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  box-shadow: 0 8px 20px rgb(15 23 42 / 12%);\n  color: #1f2933;\n  min-width: 170px;\n  padding: 8px 10px;\n  position: absolute;\n  right: 0;\n  top: 24px;\n  z-index: 2;\n}\n\n.contact-menu button:disabled {\n  color: #7b8794;\n}\n\n.compact-meta {\n  align-items: center;\n  color: #52616f;\n  display: flex;\n  gap: 5px;\n  margin: 8px 0 0;\n}\n\n.compact-meta svg {\n  fill: currentColor;\n  height: 14px;\n  width: 14px;\n}\n\n.quality-check {\n  align-items: center;\n  background: #fff7ed;\n  border: 1px solid #fed7aa;\n  border-radius: 8px;\n  display: flex;\n  gap: 8px;\n  margin: 8px 0 10px;\n  padding: 8px;\n}\n\n.quality-check span {\n  color: #9a3412;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.quality-check select {\n  border: 1px solid #fdba74;\n  border-radius: 6px;\n  flex: 1;\n  font: inherit;\n  min-width: 0;\n  padding: 6px 8px;\n}\n\n.marketing-switch {\n  align-items: center;\n  color: #52616f;\n  display: flex;\n  font-weight: 700;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n.marketing-switch input {\n  appearance: none;\n  background: #cbd5e1;\n  border: 0;\n  border-radius: 999px;\n  cursor: pointer;\n  height: 18px;\n  padding: 0;\n  position: relative;\n  transition: background 120ms ease;\n  width: 34px;\n}\n\n.marketing-switch input::after {\n  background: #ffffff;\n  border-radius: 50%;\n  content: \"\";\n  height: 14px;\n  left: 2px;\n  position: absolute;\n  top: 2px;\n  transition: transform 120ms ease;\n  width: 14px;\n}\n\n.marketing-switch input:checked {\n  background: #2563eb;\n}\n\n.marketing-switch input:checked::after {\n  transform: translateX(16px);\n}\n\n.marketing-switch input:disabled {\n  cursor: default;\n}\n\n.marketing-switch.is-enabled span {\n  color: #166534;\n}\n\n.sales-order-details {\n  gap: 6px;\n}\n\n.sales-order-details li {\n  display: block;\n}\n\n.state-badge {\n  border-radius: 999px;\n  display: inline-block;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1;\n  padding: 3px 7px;\n  width: fit-content;\n}\n\n.state-draft {\n  background: #e5e7eb;\n  color: #374151;\n}\n\n.state-sent {\n  background: #dbeafe;\n  color: #1d4ed8;\n}\n\n.state-sale,\n.state-done {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.state-cancel {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.form {\n  display: grid;\n  gap: 10px;\n}\n\n.form-actions {\n  display: flex;\n  gap: 8px;\n}\n\nlabel {\n  display: grid;\n  gap: 4px;\n}\n\n.checkbox {\n  align-items: center;\n  display: flex;\n  font-weight: 700;\n  gap: 8px;\n  margin-top: 8px;\n}\n\ninput {\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  font: inherit;\n  padding: 9px 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
